import { c as _c } from "react/compiler-runtime";
import { PlpEmptyResults } from "@/components/custom/Plp/PlpEmptyResults";
import { PlpProductGrid } from "@/components/custom/Plp/PlpProductGrid";
import { PlpResultCount } from "@/components/custom/Plp/PlpResultCount";
import { PlpUnavailable } from "@/components/custom/Plp/PlpUnavailable";
import type { ProductHit } from "@/lib/search/types";
type SearchStatus = "idle" | "loading" | "stalled" | "error";
interface Props {
  status: SearchStatus;
  total: number;
  showEmpty: boolean;
  hasQuery: boolean;
  liveQuery: string;
  hits: ProductHit[];
  onRetry: () => void;
}
export function PlpResultsBody(t0) {
  const $ = _c(12);
  const {
    status,
    total,
    showEmpty,
    hasQuery,
    liveQuery,
    hits,
    onRetry
  } = t0;
  if (status === "error") {
    let t1;
    if ($[0] !== onRetry) {
      t1 = <PlpUnavailable onRetry={onRetry} />;
      $[0] = onRetry;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== total) {
    t1 = <PlpResultCount count={total} />;
    $[2] = total;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== hasQuery || $[5] !== hits || $[6] !== liveQuery || $[7] !== showEmpty) {
    t2 = showEmpty ? <PlpEmptyResults searchVariant={hasQuery ? {
      query: liveQuery
    } : undefined} /> : <PlpProductGrid hits={hits} showMatchedAttributes={hasQuery} />;
    $[4] = hasQuery;
    $[5] = hits;
    $[6] = liveQuery;
    $[7] = showEmpty;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}